//
//  SDKShadowType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var ShadowType;
(function (ShadowType) {
    ShadowType["drop"] = "Drop";
    ShadowType["inner"] = "Inner";
})(ShadowType || (ShadowType = {}));
